import { render, staticRenderFns } from "./NotificationGroup.vue?vue&type=template&id=475ed46a&"
import script from "./NotificationGroup.vue?vue&type=script&lang=js&"
export * from "./NotificationGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports